var cacheComponent = {}, lastXhrComponent;
var timerComponent;
var locationExecSearchComponent = true;
function autoCompleteComponent(e, btn, suggestions, noSuggestion, suggestionText){
	var inputString = btn.val();
	var idResetSearch = btn.attr('id').replace("filter-name-", "button-reset-component-");
	
	if(inputString.length == 0) {
		$('#'+idResetSearch).removeClass('btn-reset-busca-show');
		suggestions.fadeOut(); // Hide the suggestions box
	}else{
		//Navigation
	   	//Down
		if(e.which == 40){
			if(suggestions.find('ul.search-results li.item a.selected').length == 0){
				suggestions.find('ul.search-results li.item').first().find('a').addClass('selected');
			} else {
		   		var selected = suggestions.find('ul.search-results li.item a.selected');
		   		if(selected.parent().is(suggestions.find('ul.search-results li.item').last())){
		   			suggestions.find('ul.search-results li.item').first().find('a').addClass('selected');
		   		} else {
		   			selected.parent() // moves up to the li element
		   				.next()   // moves to the adjacent li element
		   				.find('a')// moves down to the link
		   				.addClass('selected');
		   		}
		   		selected.removeClass('selected');
		   	}
	   	//Up			
		} else if(e.which == 38){
	   		if(suggestions.find('ul.search-results li.item a.selected').length == 0){
	   			suggestions.find('ul.search-results li.item').first().find('a').addClass('selected');
	   		} else {
	   			//Se ja estiver no primeiro remove o menu;
	   			var selected = suggestions.find('ul.search-results li.item a.selected');
	   			if(selected.parent().is(suggestions.find('ul.search-results li.item').first())) {
	   				suggestions.find('ul.search-results li.item').last().find('a').addClass('selected');
	   			} else {
	   				selected.parent() // moves up to the li element
	   					.prev()   // moves to the adjacent li element
	   					.find('a')// moves down to the link
	   					.addClass('selected');
	   			}
	   			selected.removeClass('selected');
	   			
	   		}
		 //Enter 	
		 } else if(e.which == 13){
	   		if(suggestions.find('ul.search-results li.item a.selected').length > 0){
				var loc =  suggestions.find('ul.search-results li.item a.selected').attr('href');
				if(locationExecSearchComponent){
					location = loc;
					locationExecSearchComponent = false;
	   			}
			} else {
	   			/* url = suggestions.find('base').attr('href') + 'index.php?spsr=product/search'; */
				url = 'index.php?spsr=product/search';
				if (inputString) {
					url += '&filter_name=' + encodeURIComponent(inputString);
				}
				if(locationExecSearchComponent){
					location = url;
					locationExecSearchComponent = false;
	   			}
	   		}
		 } else {
			if(inputString.length > 2 ){
				$('#'+idResetSearch).addClass('btn-reset-busca-show');
		   		var term = inputString
				if ( term in cacheComponent ) {
					autoCompleteResponseComponent( cacheComponent[ term ] , suggestions, inputString, noSuggestion, suggestionText);
					return;
				}
				clearTimeout(timerComponent);
				timerComponent =   setTimeout(function(){
					lastXhrComponent = $.post( "index.php?spsr=product/product/autocomplete&fuzzy=1&queryString=" + inputString, null, 
					function( data, status, xhr ) {
						cacheComponent[ term ] = data;
						if ( xhr === lastXhrComponent ) {
							autoCompleteResponseComponent(data , suggestions, inputString, noSuggestion, suggestionText);
						}
					});
				}, 600);
	   		}
		 }
	}
}
function autoCompleteResponseComponent(data, suggestions,termSearch, noSuggestion, suggestionText) {
	var obj = jQuery.parseJSON(data);
  	if(obj.autocomplete.length > 0){
  		var html = '<ul class="search-results">';
  		var item;
  	  	for(item in obj.autocomplete){
  	  		html += '<li class="item"><a href="index.php?spsr=product/product&product_id='+obj.autocomplete[item].product_id+'"><img src="'+obj.autocomplete[item].image+'" alt="" /><div class="searchheading"><p>'+obj.autocomplete[item].name + '</p>';
  	  		//html += '<span class="newprice">' + obj[item].price +'</span>';
  	  		html += '</div></a></li>';
  	  	}
  	  	html += '</ul>';
  	  	//VEIRIFCA html += '<a class="search-btn-results" href="index.php?spsr=product/search&filter_name='+$('input[name=filter_name]').val()+'" title="Resultados">Ver todos resultados</a>';
	  	suggestions.fadeIn(); // Show the suggestions box
       	suggestions.html(html); // Fill the suggestions box
  	} else if(obj.fuzzy_suggest.length > 0){
  		var html = '<ul class="search-term-suggestion">';
  		var item;
  	  	for(item in obj.fuzzy_suggest){
  	  		html += '<li class="item">'+ suggestionText + '<a href="index.php?spsr=product/search&filter_name='+obj.fuzzy_suggest[item]+'">'+obj.fuzzy_suggest[item]+'</a></li>';
  	  	}
  	  	html + '</ul>';
  	  	suggestions.fadeIn(); // Show the suggestions box
       	suggestions.html(html); // Fill the suggestions box
  	} else {
  		var html = '<p class="search-empty">'+ noSuggestion + '<span>'+termSearch+'</span><p>';
  	  	suggestions.fadeIn(); // Show the suggestions box
       	suggestions.html(html); // Fill the suggestions box
  	}
}
function topSearchs(data, suggestions, intro, termo) {
	html = '';
	html += data.html;
  	if(data.tops.length > 0){
  		html += '<p>'+intro+ ' '+data.tops.length+' ' +termo+'</p>';
  		html += '<ul class="search-results">';
  		var item;
  		for(item in data.tops){
			html += '<li class="item"><a href="index.php?spsr=product/search&filter_name='+data.tops[item].term_optimized+'"><span class="num-top-search">'+(parseInt(item)+1)+'</span><p>'+data.tops[item].term+'</p></a></li>';
  	  	}
  	  	html += '</ul>';
  	}
  	suggestions.fadeIn(); // Show the suggestions box
   	suggestions.html(html); // Fill the suggestions box
}
//busca	
$('.form-busca').focus(function(){
    $(this).parent().parent().addClass('busca-ativa');
}).blur(function(){
    $(this).parent().parent().removeClass('busca-ativa');
});
// autoclear function for inputs
$('.autoclear-component').click(function() {
	if (this.value == this.defaultValue) {
		this.value = '';
	}
});
$('.autoclear-component').blur(function() {
	if (this.value == '') {
		this.value = this.defaultValue;
	}
});